import { NoticeBannerProps } from '@pancakeswap/uikit'

export const NoticeBarValues: NoticeBannerProps =
{
  mainText: " !!! This is an extremely important message !!!",
  subText: "That's why it's up there, but can be clicked away. Super cool feature.",
  show: true,
  height: 60,
  noticeVersion: 3
}